// src/hooks/usePositions.js
// Device-local storage for the reader's philosophical positions, shared live
// across components via a window event (prompt cards and the Positions page
// can be mounted at the same time).
import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'philosophicalPositions';
const EVENT = 'philosophical-positions-updated';

const readPositions = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch (e) {
    return {};
  }
};

export const usePositions = () => {
  const [positions, setPositions] = useState(readPositions);

  useEffect(() => {
    const refresh = () => setPositions(readPositions());
    window.addEventListener(EVENT, refresh);
    window.addEventListener('storage', refresh);
    return () => {
      window.removeEventListener(EVENT, refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);

  const setPosition = useCallback((forkId, choice) => {
    const next = { ...readPositions(), [forkId]: { choice, at: new Date().toISOString() } };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    window.dispatchEvent(new Event(EVENT));
  }, []);

  return { positions, setPosition, answeredCount: Object.keys(positions).length };
};
